import { Col, Row } from 'antd'
import React, { Component, Fragment } from 'react'
import { Head, withRouteData } from 'react-static'
import styled from 'styled-components'
import HostsList from '../components/HostsList'
import Seperator from '../components/Seperator'

const Heading = styled.div`
  font-size: 2em;
  text-align: center;
  margin-bottom: 40px;
`

class HostGroup extends Component {
  render() {
    return (
      <Fragment>
        <Head>
          <meta name="description" content={this.props.description} />
          <title>{this.props.title}</title>
        </Head>
        <Seperator />
        <Row
          style={{ margin: '40px 0 20px' }}
          type="flex"
          align="middle"
          justify="center"
          dir="column"
        >
          <Col xs={22} sm={20} md={18} lg={18} xl={16} xxl={14}>
            <Heading>
              <span>{this.props.title}</span>
            </Heading>
            <HostsList hosts={this.props.hosts} />
          </Col>
        </Row>
        <Seperator />
      </Fragment>
    )
  }
}

export default withRouteData(HostGroup)



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/HostGroup.jsx